'use client';

import clsx from 'clsx';
import Img, { ImageProps } from 'next/image';
import { CSSProperties, useRef } from 'react';
import { CSS_VAR_ASPECT_RATIO } from '../../constants/css';
import { useLoad } from '../../hooks/load';
import styles from './Image.module.scss';

export const Image = (props: ImageProps) => {
  const ref = useRef(null);
  const load = useLoad(ref);

  const { width, height, className, unoptimized } = props;
  const style = {
    [CSS_VAR_ASPECT_RATIO]: `${width}/${height}`,
  } as CSSProperties;
  const classes = clsx(styles.base, className, {
    [styles.loaded]: load || unoptimized,
  });

  return (
    <Img {...props} unoptimized className={classes} style={style} ref={ref} />
  );
};
